import { ProgressBar } from "@spendlevel/shared-login-frontend";
import { useState } from "react";

function IFrame() {
    const [showProgressBar, setShowProgressBar] = useState(true);
    const [displayIframe, setDisplayIframe] = useState('none');

    const handleLoad = () => {
        setDisplayIframe('inline-block');
        setShowProgressBar(false);
    }
    
    return (
        <div className="login login-v2 fw-bold">
            <div className="login-cover">
                <div className="login-cover-img" style={{ backgroundImage: 'url(/assets/login-bg-17.jpg)' }}></div>
                <div className="login-cover-bg">
                    {showProgressBar && <ProgressBar/>}
                    <div style={{width: "100%", height: "100%"}}>
                        <iframe title="Secure Site" src="/secure" style={{width: "100%", height: "100%", display: displayIframe}} onLoad={handleLoad} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IFrame;